<template>
  <div class="vinput">
    <label :for-id="id" class="vinput-label">{{ label }}</label>
    <div class="vinput-wr">
      <textarea
        :id="id"
        ref="input"
        v-bind="$attrs"
        :type="type"
        class="vinput-input"
        @blur="handleBlur"
        @focus="handleFocus"
        @input="handleInput"
      />
    </div>
  </div>
</template>

<script>
import {uuid} from 'UTILS';

export default {
  name: 'VInput',
  inheritAttrs: false,
  props: {
    value: [String, Number],
    type: {
      type: String,
      default: 'text',
    },
    tmp: {
      type: String,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      id: '',
      isFocused: false,
      isBlured: false,
      text: '',
    };
  },
  computed: {
    nativeInputValue() {
      return this.value === null || this.value === undefined ? '' : String(this.value);
    },
  },
  watch: {
    nativeInputValue() {
      this.setNativeInputValue();
    },
    value(val) {
      if ((val === null || val === undefined || val === '') && !this.tmp) {
        this.isFocused = false;
      } else {
        this.isFocused = true;
      }
    },
  },
  beforeMount() {
    this.id = uuid();
  },
  mounted() {
    this.isFocused = !!this.value;
    this.setNativeInputValue();
  },
  methods: {
    getInput() {
      return this.$refs.input;
    },
    clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
    },
    handleChange(event) {
      this.$emit('change', event.target.value);
    },
    setNativeInputValue() {
      const input = this.getInput();
      if (!input) {
        return;
      }
      if (input.value === this.nativeInputValue) return;
      input.value = this.nativeInputValue;
    },
    handleInput(event) {
      if (event.target.value === this.nativeInputValue) return;
      this.$emit('input', event.target.value);
      this.$nextTick(this.setNativeInputValue);

      if (event !== '') {
        this.isBlured = false;
        this.isFocused = true;
      } else {
        this.isBlured = true;
        this.isFocused = false;
      }
    },
    handleFocus(event) {
      if (event !== '') {
        this.isBlured = false;
        this.isFocused = true;
      }
    },
    handleBlur() {
      this.$emit('blur', this.value);
      if (!this.value && !this.tmp) {
        this.isFocused = false;
        this.isBlured = true;
      }
    },
  },
};
</script>

<style scoped>
.vinput {
  position: relative;
  box-sizing: border-box;
}
.vinput * {
  box-sizing: border-box;
}
.vinput-input {
  display: block;
  min-height: 50px;
  padding: 10px 15px;
  color: inherit;
  background-color: var(--input-bg-color);
  border: 1px solid var(--input-border-color);
  border-radius: var(--input-border-radius);
  font-family: 'Montserrat_SemiBold', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-variation-settings: 'wght' 400;
  font-size: 18px;
  width: 100%;
  outline: none;
}
.vinput-input:focus,
.vinput-input:hover {
  color: var(--input-text-color-active);
  background-color: var(--input-bg-color-active);
  border: 1px solid var(--input-border-color-active);
}
.vinput-input::placeholder {
  color: currentColor;
  font-size: inherit;
  opacity: 0.5;
}
.vinput-label {
  display: flex;
  line-height: inherit;
  color: var(--input-label-color);
  font-size: 14px;
  margin-bottom: 10px;
}
.vinput-tmp {
  position: absolute;
  font-size: inherit;
  line-height: inherit;
  color: currentColor;
  word-spacing: 0;
}
.vinput_append-icon {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
}
.vinput-wr {
  position: relative;
}
</style>
